// package select
document.querySelectorAll('.pkg').forEach(p=>p.addEventListener('click',()=>{
  document.querySelectorAll('.pkg').forEach(x=>x.classList.remove('is-active'));
  p.classList.add('is-active');
  document.getElementById('sk-name').textContent=p.dataset.name;
  document.getElementById('sk-price').textContent=p.dataset.price;
}));
// sticky after hero
const hero=document.querySelector('.hero'),sk=document.getElementById('sticky');
addEventListener('scroll',()=>{sk.classList.toggle('show',hero.getBoundingClientRect().bottom<0);},{passive:true});
// before/after slider (ortadan kayan çizgi)
document.querySelectorAll('[data-ba]').forEach(function(s){
  var before=s.querySelector('.ba-before'),line=s.querySelector('.ba-line'),grip=s.querySelector('.ba-grip');
  function set(pos){pos=Math.max(2,Math.min(98,pos));if(before){before.style.clipPath='inset(0 '+(100-pos)+'% 0 0)';}line.style.left=pos+'%';grip.style.left=pos+'%';}
  function move(e){var r=s.getBoundingClientRect();var cx=(e.touches?e.touches[0].clientX:e.clientX)-r.left;set(cx/r.width*100);}
  var drag=false;
  s.addEventListener('pointerdown',function(e){drag=true;move(e);});
  window.addEventListener('pointermove',function(e){if(drag)move(e);});
  window.addEventListener('pointerup',function(){drag=false;});
  set(50);
});